import { useMemo, useState } from 'react'
import Paper from '@mui/material/Paper'
import EnteranceEventsFeedList from './EnteranceEventsFeedList'
import EnteranceEventsFeedToolbar from './EnteranceEventsFeedToolbar'

// EnteranceEventsFeed.propTypes = {
//   channelsData: PropTypes.array,
// }
const EnteranceEventsFeed = ({ channelsData = [] }) => {
  const [channelIds, setChannelIds] = useState()
  const [searchQuery, setSearchQuery] = useState('')

  const onSearchQueryChange = (value) => {
    
    const normalizedValue = String(value || '')
      .trim()
      .toUpperCase()
    setSearchQuery(normalizedValue)
  }

  const channelNameById = useMemo(() => {
    return channelsData.reduce((acc, channel) => {
      if (channel?.id != null) {
        acc[channel.id] = channel.name
      }
      return acc
    }, {})
  }, [channelsData])

  return (
    <Paper
      elevation={8}
      sx={(theme) => ({
        display: 'flex',
        flexDirection: 'column',
        borderRadius: 2,
        height: {
          xs: `calc(${theme.constants.widgetMaxHeight.xs} - 4px)`,
          md: theme.constants.widgetMaxHeight.md,
        },
        position: 'sticky',
        top: {
          xs: theme.constants.widgetOffsetTop ,
          md: theme.constants.widgetOffsetTop + 16,
        },
      })}
    >
      <EnteranceEventsFeedToolbar
        channelsList={channelsData}
        onChannelIdsChange={setChannelIds}
        onSearchQueryChange={onSearchQueryChange}
      />
      <EnteranceEventsFeedList
        key={channelIds} // force re-render when channelIds changes
        channelIds={channelIds}
        channelNameById={channelNameById}
        searchQuery={searchQuery}
      />
    </Paper>
  )
}

export default EnteranceEventsFeed
